import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var tableThemeWeb = {
  color: 'primary',
  textColor: 'text',
  background: 'background',
  border: colors.cloudGrey,
  zebraHighlight: colors.lightGrey
};

var tableDarkThemeWeb = _extends({}, tableThemeWeb, {
  border: colors.fogGrey,
  zebraHighlight: colors.mineShaftGrey
});

export { tableDarkThemeWeb, tableThemeWeb };